import { render, staticRenderFns } from "./extras-list.vue?vue&type=template&id=cf95988e&scoped=true"
import script from "./extras-list.vue?vue&type=script&lang=js"
export * from "./extras-list.vue?vue&type=script&lang=js"
import style0 from "./extras-list.vue?vue&type=style&index=0&id=cf95988e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf95988e",
  null
  
)

export default component.exports